import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SLCPage from './pages/SLCPage';
import TCPage from './pages/TCPage';
import BonafidePage from './pages/BonafidePage';
import ResultsPage from './pages/ResultsPage';
import ReportCardPage from './pages/ReportCardPage';
import SettingsPage from './pages/SettingsPage';
import GeneratedCertsPage from './pages/GeneratedCertsPage';
import FieldSettingsPage from './pages/FieldSettingsPage';
import AdmitCardPage from './pages/AdmitCardPage';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/:schoolId"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="results" element={<ResultsPage />} />
          <Route path="report-cards" element={<ReportCardPage />} />
          <Route path="slc" element={<SLCPage />} />
          <Route path="tc" element={<TCPage />} />
          <Route path="bonafide" element={<BonafidePage />} />
          <Route path="admit-card" element={<AdmitCardPage />} />
          <Route path="generated-certs" element={<GeneratedCertsPage />} />
          <Route path="field-settings" element={<FieldSettingsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route index element={<Navigate to="dashboard" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
